import React, { useEffect, useState } from 'react';
import {
    IconButton,
    Switch,
    Grid,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    AppBar,
    InputBase,
    InputAdornment,
    makeStyles,
    DialogActions,
    Divider,
    ListItem,
    List
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { getConsigneeList, getConsignorList } from '../../../store/actions/tripActionCreator';
import * as logger from '../../../logger';
import EditIcon from '@material-ui/icons/Edit';
import Highlighter from "react-highlight-words";
import AddConsigneeConsignorDetails from './AddConsigneeConsignorDialog';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        color: '#9ea0a5',
        fontSize: 18
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    dialogTitleV1: {
        paddingTop: 12,
        paddingBottom: '24px !important',
        paddingRight: 0,
        paddingLeft: 0
    },
    divV1: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 24,
        paddingRight: 24,
    },
    paperWidth: {
        width: 448,
        height: 665,
        maxWidth: 448,
        maxHeight: 665
    },
    paper1: {
        borderRadius: 4
    },
    appBar: {
        marginTop: 14,
        display: 'flex',
        justifyContent: 'center',
        height: 72,
        backgroundColor: '#f1f1f3',
        boxShadow: 'none',
        paddingLeft: 24,
        paddingRight: 24
    },
    inputV1: {
        backgroundColor: 'white',
        height: 40,
        width: '100%',
        borderRadius: 8,
        '& .MuiInputBase-input': {
            paddingLeft: 16,
            paddingRight: 16
        }
    },
    searchIcon: {
        color: 'grey',
        fontSize: 26,
        marginRight: 6
    },
    divButton: {
        marginTop: 16,
        paddingLeft: 24,
        paddingRight: 24
    },
    buttonV1: {
        borderRadius: 8,
        border: '1px solid #5170f0',
        fontSize: 16,
        paddingTop: 12,
        paddingBottom: 12,
        color: '#5170f0',
        textTransform: 'capitalize'
    },
    addIcon: {
        fontSize: 18,
        marginRight: 8,
        marginTop: 1
    },
    daV1: {
        paddingTop: 21,
        paddingBottom: '21px !important',
        paddingLeft: 23,
        paddingRight: 23,
        backgroundColor: '#f1f1f3'
    },
    closeButton: {
        borderRadius: 4,
        fontWeight: 500,
        fontSize: 14,
        textTransform: 'capitalize',
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 19,
        paddingRight: 19,
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        '&:hover': {
            backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    dialogContentV1: {
        paddingTop: 0,
        paddingBottom: 24,
        paddingLeft: 8,
        paddingRight: 8
    },
    editButton: {
        fontSize: 12,
        color: '#5170f0'
    },
    editIconV1: {
        fontSize: 16
    },
    divV2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    divName: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    divAddress: {
        color: '#8a8d97',
        fontWeight: 'bold',
        fontSize: 12
    },
    listItemV1: {
        paddingBottom: '16px !important',
        paddingTop: '16px !important',
        display: 'flex',
        flexDirection: 'column'
    },
    textV1: {
        color: '#5170f0',
        backgroundColor: 'white',
        padding: 0
    }
}));

const ConsigneeConsignorSelect = ({ open, onClose, onConfirm, onSelect, type, trip, user, dispatchGetConsigneeList, dispatchGetConsignorList }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [consignorConsigneeList, setConsignorConsigneeList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [addNewDialog, setAddNewDialog] = useState(false);
    const [editData, setEditData] = useState({});
    const [editFlag, setEditFlag] = useState(false);

    const classes = useStyles();

    useEffect(() => {

        if (type == "consignor") {
            dispatchGetConsignorList(
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Consignee Consignor Select Dweb', 'Get Consignor list successfull');
                    }
                },
                () => {
                    logger.log('Consignee Consignor Select Dweb', 'Get Consignee list Failed');
                }
            )
        } else if (type == "consignee") {
            dispatchGetConsigneeList(
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Consignee Consignor Select Dweb', 'Get Consignee list successfull');
                    }
                },
                () => {
                    logger.log('Consignee Consignor Select Dweb', 'Get Consignee list Failed');
                }
            )
        }

    }, []);

    useEffect(() => {

        if (type == "consignor" && trip && trip.consignorList && trip.consignorList.length > 0) {
            setConsignorConsigneeList(trip.consignorList);
        }
        if (type == "consignee" && trip && trip.consigneeList && trip.consigneeList.length > 0) {
            setConsignorConsigneeList(trip.consigneeList);
        }

    }, [trip.consigneeList, trip.consignorList])

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleSearch = (text) => {

        setSearchText(text && (text.trim()).length > 0 ? text : "");

        let list;
        let search = text;

        if (type == "consignor") {
            list = trip.consignorList;
        } else if (type == "consignee") {
            list = trip.consigneeList;
        }

        if (text && (text.trim()).length > 0) {
            list = list.filter((listData) => (
                listData && listData.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
            ))
        }

        setConsignorConsigneeList(list);

    }

    const handleAdd = () => {
        setAddNewDialog(true);
        setEditFlag(false);
        setEditData({});
    }

    const handleAddNewDialogClose = () => {
        setAddNewDialog(false);
    }

    const handleEdit = (listData) => {
        setEditFlag(true);
        setEditData(listData);
        setAddNewDialog(true);
    }

    const handleAddNewDialogConfirm = () => {
        handleClose();
    }

    const handleListClick = (listData) => {
        onSelect(listData);
        handleClose();
    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                maxWidth="sm"
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                aria-labelledby="add-driver-dialog-title"
                open={dialogOpen}
                classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}
                onClose={handleClose}
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>
                        <div className={classes.divTitle}>
                            {type == "consignor" &&
                                "Select Consignor"
                            }
                            {type == "consignee" &&
                                "Select Consignee"
                            }
                        </div>
                        <div>
                            <IconButton className={classes.iconButton} onClick={() => handleClose()} >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>

                    <div>
                        <AppBar position="static" className={classes.appBar}>
                            <div>
                                <InputBase
                                    placeholder={"Search " + type}
                                    className={classes.inputV1}
                                    inputProps={{ 'aria-label': 'search' }}
                                    value={searchText}
                                    onChange={(e) => { handleSearch(e.target.value) }}
                                    autoFocus
                                    endAdornment={
                                        <InputAdornment position="start">
                                            <SearchIcon className={classes.searchIcon} />
                                        </InputAdornment>
                                    }
                                />
                            </div>
                        </AppBar>
                    </div>

                    <div className={classes.divButton}>
                        <Button variant="outlined" className={classes.buttonV1} fullWidth onClick={() => handleAdd()}>
                            <AddIcon className={classes.addIcon} />
                            <span>Add new {type}</span>
                        </Button>
                    </div>

                </DialogTitle>

                <DialogContent className={classes.dialogContentV1} >
                    <>
                        {consignorConsigneeList && consignorConsigneeList.length > 0 && consignorConsigneeList.map((listData, index) => (
                            <>
                                <List>
                                    <ListItem button className={classes.listItemV1} onClick={(e) => {
                                        handleListClick(listData)
                                    }}>
                                        <div className={classes.divV2}>
                                            <div>
                                                <div className={classes.divName}>
                                                    {/* {getHighlightedText(listData.name, searchText)} */}
                                                    <Highlighter
                                                        highlightClassName={classes.textV1}
                                                        searchWords={[searchText]}
                                                        autoEscape={true}
                                                        textToHighlight={listData.name}
                                                    />
                                                </div>
                                                <div className={classes.divAddress}>{listData.address_line_1}</div>
                                            </div>
                                            <div>
                                                <IconButton className={classes.editButton} onClick={(e) => {
                                                    handleEdit(listData)
                                                    e.stopPropagation()
                                                }}>
                                                    <EditIcon className={classes.editIconV1} />
                                                </IconButton>
                                            </div>
                                        </div>
                                    </ListItem>
                                    {index != consignorConsigneeList.length - 1 &&
                                        <Divider light className={classes.dividerV1} />
                                    }
                                </List>
                            </>
                        ))
                        }
                    </>
                </DialogContent>

                <DialogActions className={classes.daV1}>
                    <Button variant="contained" className={classes.closeButton} onClick={() => handleClose()}>
                        Close
                    </Button>
                </DialogActions>

            </Dialog>

            {addNewDialog && <AddConsigneeConsignorDetails open={addNewDialog} onClose={handleAddNewDialogClose} onConfirm={handleAddNewDialogConfirm} checkType={(type.replace(/\b(\w)/g, s => s.toUpperCase()))} editData={editData} edit={editFlag} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetConsignorList: (onSuccess, onError) => {
        dispatch(getConsignorList(onSuccess, onError))
    },
    dispatchGetConsigneeList: (onSuccess, onError) => {
        dispatch(getConsigneeList(onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConsigneeConsignorSelect)